import script from "./petList.vue?vue&type=script&setup=true&lang=js"
export * from "./petList.vue?vue&type=script&setup=true&lang=js"

import "./petList.vue?vue&type=style&index=0&id=2a405aa4&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a405aa4"]])

export default __exports__